export const getValues = (array) => array.map((el) => el.value);

export const getMeteocodeValues = (meteocodes) => {
  let str = '';
  meteocodes.forEach((meteocode, index) => {
    str += `${meteocode.value}${meteocode.entityId ? `|${meteocode.entityId}` : ''}`;
    if (index !== meteocodes.length - 1) {
      str += ';';
    }
  });
  return str;
};

export const parseMeteocodeValues = (str) => {
  const obj = str.split(';');
  const newObjs = [];
  obj.forEach((s) => {
    const [value, entityId] = s.split('|');
    newObjs.push({ value: parseInt(value, 10), entityId: entityId ? parseInt(entityId, 10) : -1 });
  });
  return newObjs;
};

export const filterMeteocodeValue = (array, values) => {
  const newValues = parseMeteocodeValues(Array.isArray(values) ? values[0] : values);
  const newArray = [];

  newValues.forEach((meteocode) => {
    const findIndex = array.findIndex(({ value, entities }) => meteocode.value === value && entities?.includes(meteocode.entityId));
    if (findIndex !== -1) {
      newArray.push({
        ...array[findIndex],
        ...meteocode,
      });
    }
  });
  return newArray;
};

export const filterValueByIncludes = (array, values) => array.filter((el) => values.includes(el.value));

export const sortByVocMode = (meteocodes, selectedVocModeIds) => {
  // TODO: не очень сортировка (но так они не прыгают с места на место используя sort)
  const stormRegime = meteocodes.filter(({ vocModes }) => vocModes.length === 1 && vocModes[0] === 2);
  const filtered = meteocodes.filter(({ vocModes }) => vocModes.includes(1)); // метеокоды со штатным режимом
  const noMode = meteocodes.filter(({ vocModes }) => vocModes.includes(3));
  // сортируем по выбранным режимам
  return [...filtered, ...stormRegime, ...noMode].filter(({ vocModes: mVocModes }) => mVocModes.some((mode) => selectedVocModeIds.includes(mode)));
};
